import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import { DateProvider } from '../../../providers';
import FontFamilyHeader from '../../FontFamilyHeader';
import { Card, Container, Logo, Sentence, Time, Winner, Word } from './styles';

function WordGuessingLogo({ data, styles }) {
  const [, refresh] = useState(Date.now());
  const { gameInitializedUntil, logo, sentence, winner } = data;
  const { card, reveal } = styles || {};

  const fontFamily = FONT_FAMILY[styles?.reveal?.font || 'notoSans'];
  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'notoSans'];

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (!gameInitializedUntil) clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [gameInitializedUntil]);

  const words = sentence.split(' ');

  const emitEvent = (cardNumber) => {
    const event = new CustomEvent('cardClicked', { detail: cardNumber });
    window.dispatchEvent(event);
  };

  const getGuessingTime = () => {
    const [minutes, seconds] = DateProvider.getTimeUntil(gameInitializedUntil);

    return `${minutes}:${seconds}`;
  };

  const getLetterIndex = (wordIndex, letterIndex) => {
    let index = 1;
    words.forEach((word, indexWord) => {
      if (indexWord < wordIndex) {
        index += word.length;
      } else if (indexWord === wordIndex) {
        index += letterIndex;
      }
    });
    return index;
  };

  return (
    <>
      <FontFamilyHeader family={fontFamily} />
      <FontFamilyHeader family={fontFamilyTimer} />
      <Container>
        {gameInitializedUntil && (
          <Time
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
              lineHeight: styles?.timer?.size
                ? `${styles?.timer?.size}px`
                : undefined,
            }}
          >
            {getGuessingTime()}
          </Time>
        )}
        {!!winner && (
          <Winner
            style={{
              background: reveal?.background,
              border: `6px solid ${reveal?.border}`,
              color: reveal?.color,
            }}
          >{`${winner} WINS!!`}</Winner>
        )}
        <Sentence>
          {words.map((word, indexWord) => {
            const letters = word.split('');

            return (
              <Word key={`${word}-${indexWord}`}>
                {letters.map((letter, index) => {
                  const letterIndex = getLetterIndex(indexWord, index);
                  const showLetter =
                    !!winner || data.reveal.includes(letterIndex);
                  return (
                    <Card
                      key={`${word}-${indexWord}-${letter}-${index}`}
                      onClick={() => emitEvent(letterIndex)}
                      showLetter={showLetter}
                      style={{
                        background: showLetter
                          ? reveal?.background
                          : card?.background,
                        border: `6px solid ${
                          showLetter ? reveal?.border : card?.border
                        }`,
                        color: showLetter && reveal?.color,
                        fontFamily: fontFamily?.family,
                        fontSize: reveal.size,
                        lineHeight: reveal.size
                          ? `${reveal.size}px`
                          : undefined,
                      }}
                    >
                      {!showLetter && logo && <Logo src={logo} alt="logo" />}
                      {showLetter && letter}
                    </Card>
                  );
                })}
              </Word>
            );
          })}
        </Sentence>
      </Container>
    </>
  );
}

WordGuessingLogo.propTypes = {
  data: PropTypes.shape({
    logo: PropTypes.string,
    reveal: PropTypes.arrayOf(PropTypes.number),
    sentence: PropTypes.string,
    time: PropTypes.number,
    winner: PropTypes.string,
  }),
  styles: PropTypes.shape({
    card: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
    }),
    reveal: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      size: PropTypes.number,
    }),
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

WordGuessingLogo.defaultProps = {
  data: {
    logo: 'https://overlayon.s3.eu-west-3.amazonaws.com/overlayon.png',
    reveal: [],
    sentence: 'Overlay on',
    winner: null,
  },
  styles: {
    card: {
      background: '#000000',
      border: '#90caf9',
    },
    reveal: {
      background: '#90caf9',
      border: '#000000',
      color: '#000000',
      font: 'notoSans',
      size: 80,
    },
    timer: {
      color: '#FFFFFF',
      font: 'notoSans',
      letterSpacing: 0,
      size: 30,
    },
  },
};

export default WordGuessingLogo;
